import React from 'react';
import { Footer } from '../newhome/Footer'
import { Header } from '../newhome/Header'
import TermsOfServiceContent from './terms-of-service-content.component';

const TermsOfServicePage = () => (
  <>
    <Header />
      <TermsOfServiceContent />
    <Footer />
  </>
);

export default TermsOfServicePage;
